"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSSGrid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var css_grid_scss_1 = tslib_1.__importDefault(require("./css-grid.scss"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var getFractionString = function (n, minItemWidth) {
    var unit = minItemWidth ? "minmax(".concat(minItemWidth, "px, 1fr)") : '1fr';
    return Array(n).fill(unit).join(' ');
};
var CSSGrid = /** @class */ (function (_super) {
    tslib_1.__extends(CSSGrid, _super);
    function CSSGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.containerClassName = "".concat(_this.props.styleId, "-").concat(_this.props.gridId);
        _this.containerRef = react_1.default.createRef();
        _this.state = {
            isClient: false,
        };
        return _this;
    }
    CSSGrid.prototype.componentDidMount = function () {
        if (this.containerRef.current) {
            this.containerRef.current.style.gridTemplateColumns = '';
            this.containerRef.current.style.msGridColumns = '';
        }
        if (typeof window !== 'undefined') {
            this.setState({ isClient: true });
        }
    };
    CSSGrid.prototype.getCss = function () {
        var _a = this.props, _b = _a.rows, rows = _b === void 0 ? 1 : _b, _c = _a.cols, cols = _c === void 0 ? 1 : _c, minItemWidth = _a.minItemWidth;
        var styleContent = ".".concat(this.containerClassName, " {\n      grid-template-rows: ").concat(getFractionString(rows), ";\n      -ms-grid-rows: ").concat(getFractionString(rows), ";\n      -ms-grid-columns: ").concat(getFractionString(cols, minItemWidth), ";\n      grid-template-columns: ").concat(getFractionString(cols, minItemWidth), ";\n    }");
        for (var row = 1; row <= rows; row++) {
            for (var col = 1; col <= cols; col++) {
                var cellNum = col + cols * (row - 1);
                var cellStyle = ".".concat(this.containerClassName, " > *:nth-child(").concat(cellNum, ") {-ms-grid-row: ").concat(row, "; -ms-grid-column: ").concat(col, ";}");
                styleContent += cellStyle;
            }
        }
        return styleContent;
    };
    CSSGrid.prototype.render = function () {
        var _a = this.props, style = _a.style, children = _a.children;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("style", { key: this.state.isClient ? 'first-pass' : 'second-pass', dangerouslySetInnerHTML: { __html: this.getCss() } }),
            react_1.default.createElement("div", { ref: this.containerRef, className: (0, classnames_1.default)(css_grid_scss_1.default.container, this.containerClassName), style: style }, children)));
    };
    return CSSGrid;
}(react_1.default.Component));
exports.CSSGrid = CSSGrid;
//# sourceMappingURL=css-grid.js.map